<html>

  <head>

  </head>

  <body style="background: #424242;
  display: flex;
  align-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;">

    <p style="text-align: center;
    font-size: 26px;
    color: white;">Front Elevation</p>

    <img style="max-width: 500px; max-height: 500px;" [src]=" 'https://fastfieldphotos.s3.amazonaws.com/' + this.camData.FrontElev_Pic"/>

    <p style="text-align: center;
    font-size: 26px;
    color: white;">Cleanout 1 </p>
    <img style="max-width: 500px; max-height: 500px;" [src]=" 'https://fastfieldphotos.s3.amazonaws.com/' + this.camData.Cleanout1_Pic"/>
    <p style="text-align: center;
    font-size: 26px;
    color: white;">Cleanout 2 </p>
    <img style="max-width: 500px; max-height: 500px;" [src]=" 'https://fastfieldphotos.s3.amazonaws.com/' + this.camData.Cleanout2_Pic"/>

    <a style="color: white;" [href]=" 'https://fastfieldphotos.s3.amazonaws.com/' + this.camData.Video1_Vid " target="blank" download>Download Scope Video 1</a>
    <a style="color: white;" [href]=" 'https://fastfieldphotos.s3.amazonaws.com/' + this.camData.Video2_Vid " target="blank" download>Download Scope Video 2</a>


  </body>

</html>
